import "./FineDetails.css";

import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { setCurrentStep } from "../../../store/fine/fineActions";

const FineDetails = () => {
  const currentStep = useAppSelector((state) => state.fine.currentStep);
  const dispatch = useAppDispatch();
  const infringement = useAppSelector((state) => state.fine.infringement);
  const user = useAppSelector((state) => state.auth.user);

  const onPayClicked = () => {
    dispatch(setCurrentStep(currentStep + 1));
  };

  return (
    <div className="step-container">
      <p className="step-title">Traffic fine details</p>
      <br />
      <div className="fine-details-container">
        <div className="fine-line-item">
          <p>Offender:</p>
          <p>{infringement?.offenderName}</p>
        </div>
        <br />
        <p>Offense Details</p>
        <div className="fine-line-item">
          <p>Notice Number:</p>
          <p>{infringement?.noticeNumber}</p>
        </div>
        <div className="fine-line-item">
          <p>Offense Date:</p>
          <p>{infringement?.offenceDate}</p>
        </div>
        <div className="fine-line-item">
          <p>Vehicle Reg Number:</p>
          <p>{infringement?.registrationNumber}</p>
        </div>
        {/* <div className="fine-line-item">
          <p>Issuing Authority:</p>
          <p>{infringement.iss}</p>
        </div> */}
        <div className="fine-line-item">
          <p>Offense Location:</p>
          <p>{infringement?.offenceLocation}</p>
        </div>
        <div className="fine-line-item">
          <p>Offense Description:</p>
          <p>{infringement?.offenceType}</p>
        </div>
        <div className="fine-line-item">
          <p>Speed:</p>
          <p>{infringement?.speed}</p>
        </div>
        {infringement?.caseNumber && (
          <div className="fine-line-item">
            <p>Case Number:</p>
            <p>{infringement?.caseNumber}</p>
          </div>
        )}
        {infringement?.warrantNumber && (
          <div className="fine-line-item">
            <p>Warrant Number:</p>
            <p>{infringement?.warrantNumber}</p>
          </div>
        )}
        {infringement?.summonsNumber && (
          <div className="fine-line-item">
            <p>Summons Number:</p>
            <p>{infringement?.summonsNumber}</p>
          </div>
        )}
        <br />
        {infringement?.courtName && (
          <>
            <p>Court Details</p>
            <div className="fine-line-item">
              <p>Court:</p>
              <p>{infringement?.courtName}</p>
            </div>
            <br />
          </>
        )}

        <p>Payment Details</p>
        {infringement?.statusDescription && (
          <div className="fine-line-item">
            <p>Status:</p>
            <p>{infringement.statusDescription}</p>
          </div>
        )}

        {infringement?.dueDate && (
          <div className="fine-line-item">
            <p>Due Date:</p>
            <p>{infringement.dueDate}</p>
          </div>
        )}

        {infringement?.amount ? (
          <div className="fine-line-item">
            <p>Fine Amount:</p>
            {infringement?.contemptOfCourtAmount ? (
              <p>
                R
                {(infringement!.amount - infringement!.contemptOfCourtAmount) /
                  100}
              </p>
            ) : (
              <p>R{infringement!.amount / 100}</p>
            )}
          </div>
        ) : null}

        {infringement?.contemptOfCourtAmount ? (
          <div className="fine-line-item" id="contempt">
            <p>Contempt of Court Amount:</p>
            <p>R{infringement!.contemptOfCourtAmount / 100}</p>
          </div>
        ) : null}

        <div className="divider" />
        {infringement?.amount && infringement.contemptOfCourtAmount ? (
          <div className="totals-section" id="total">
            <p>Total:</p>
            <p>R{infringement?.amount! / 100}</p>
          </div>
        ) : (
          <div className="totals-section" id="total">
            <p>Total:</p>
            <p>R{infringement?.amount! / 100}</p>
          </div>
        )}
      </div>
      <div className="continue-to-payment" onClick={() => onPayClicked()}>
        <p>Continue to Payment</p>
      </div>
    </div>
  );
};

export default FineDetails;
